"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreMembers = exports.moreMembersTestId = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Avatar_1 = require("../../../util/Avatar/Avatar");
exports.moreMembersTestId = 'more-subscription-members';
const MoreMembers = (props) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { moreNumber } = props;
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: translate('more-members-members_count', { count: moreNumber }), children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { component: "span", mr: 0.5, children: (0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { "data-testid": exports.moreMembersTestId, avatar: `+${moreNumber}`, avatarType: Avatar_1.AvatarType.INITIALS_AVATAR, size: "large" }) }) }));
};
exports.MoreMembers = MoreMembers;
//# sourceMappingURL=MoreMembers.js.map